import {AfterViewChecked, Component, Inject, OnInit, ViewChild} from '@angular/core';

import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CropperSettings, ImageCropperComponent} from 'ngx-img-cropper';
import {APIHelper} from '../../../../shared/services/api-helper/api-helper.service';

import {StorageService} from '../../../../shared/services/storage/storage.service';
import {Room} from '../shared/models/room.class';
import {RoomService} from '../shared/services/room/room.service';

@Component({
    selector: 'app-add-room',
    templateUrl: './add-room.component.html',
    styleUrls: ['./add-room.component.scss']
})
export class AddRoomComponent implements OnInit, AfterViewChecked {
    public cropperSettings: CropperSettings;
    public dataImage: any;
    public initialDataImage: any;
    public roomForm: FormGroup;
    public loading: boolean;
    public isEdit = false;
    public room: Room;
    public hasImageChanged: boolean;
    @ViewChild('cropper') cropper: ImageCropperComponent;

    constructor(private api: APIHelper,
                private fb: FormBuilder,
                private roomService: RoomService,
                @Inject(MAT_DIALOG_DATA) public dataParams: any,
                public dialogRef: MatDialogRef<AddRoomComponent>,
                private storage: StorageService) {
    }

    ngOnInit() {
        this.dataImage = {};
        this.hasImageChanged = false;
        this.loading = false;
        this.room = null;

        if (this.dataParams && this.dataParams.edit) {

          this.isEdit = true;
            this.room = this.dataParams.room;
        }

        // Initialiser création formulaire
        this.initialize();

        this.cropperSettings = new CropperSettings();
        this.cropperSettings.croppingClass = 'croppingDone';
        this.cropperSettings.cropperClass = 'cropper';
        this.cropperSettings.width = 240;
        this.cropperSettings.height = 240;
        this.cropperSettings.croppedWidth = 240;
        this.cropperSettings.croppedHeight = 240;
        this.cropperSettings.canvasWidth = 400;
        this.cropperSettings.canvasHeight = 300;
    }

    ngAfterViewChecked() {
        if (this.isEdit && this.room.picture) {
            if (this.cropper && this.cropper.image && this.cropper.image.image) {
                return;
            }
            const image = new Image();
            const ticketToken = this.storage.getAsync({key: 'token'});
            image.src = `/alfresco/api/-default-/public/alfresco/versions/1/nodes/${this.room.picture}` +
                `/content?attachment=false&alf_ticket=${ticketToken}`;

            this.cropper.setImage(image);

            setTimeout(() => {
                this.initialDataImage = this.cropper.image.image;
            }, 1000);
        }
    }

    private initialize() {
        this.roomForm = this.fb.group({
            salleName: [this.isEdit ? this.room.salleName : '', Validators.required],
            equipments: [this.isEdit ? this.room.equipments : ''],
            description: [this.isEdit ? this.room.description : ''],
            picture: [this.isEdit ? this.room.picture : ''],
            color: [this.isEdit ? this.room.color : this.getRandomColor(), Validators.required],
            allowedParticipants: [this.isEdit ? this.room.allowedParticipants : 5, [Validators.required, Validators.min(2)]]
        });
    }

    addRoom() {
        this.loading = true;
        let f: File = null;

        if (this.dataImage.original) {
            const jpg = this.dataImage.image.split(',')[1];
            const byteCharacters = atob(jpg);
            const byteNumbers = new Array(byteCharacters.length);

            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);

            const filename = this.roomForm.controls.salleName.value;
            const b: Blob = new Blob([byteArray], {type: 'image/jpeg'});
            f = this.blobToFile(b, filename + '.jpg');
        }

        let promise = null;
        if (this.isEdit &&
            (
                (!this.dataImage.image && !this.room.picture) ||
                ((this.dataImage.image ? this.dataImage.image.length : 0) === (this.initialDataImage ? this.initialDataImage.length : 0))
            )
        ) {
            promise = new Promise((r) => r(this.room.picture || null));
        } else {
            promise = this.roomService.uploadProfileImage(f);
        }

        promise
            .then((res: any) => {
                const data = this.roomForm.value;

                if (res) {
                    data.picture = res;
                }

                if (this.isEdit) {
                    data.creator = '';
                    return this.roomService.editRoom(data, this.room.id);
                } else {
                    return this.roomService.addRoom(data);
                }
            })
            .then((res: Room) => {
                this.dialogRef.close(res);
            });
    }

    private getRandomColor() {
        const colors: string[] = ['FFFFF0', '00BFFF', 'FFE4C4', 'F5DEB3', 'E6E6FA', 'FFC0CB', 'DDA0DD', 'FA8072', '40E0D0', 'FFFF99', 'FF99CC', 'CCFFFF', '66CCFF', 'F4A460', 'ADFF2F', 'AFEEEE', '87CEFA', 'FFB6C1', 'F5DEB3', 'F0E68C'];
        return '#' + colors[Math.floor(Math.random() * colors.length)];
    }

    private blobToFile(theBlob: Blob, fileName: string): File {
        const b: any = theBlob;
        // A Blob() is almost a File() - it's just missing the two properties below which we will add
        b.lastModifiedDate = new Date();
        b.name = fileName;

        // Cast to a File() type
        return <File>theBlob;
    }

}
